export default __webpack_public_path__ + "static/media/aboutUsImage.952b2b50.png";